import { render } from "./DateTimeColumn.vue?vue&type=template&id=c76ba2ce"
import script from "./DateTimeColumn.vue?vue&type=script&lang=js"
export * from "./DateTimeColumn.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__